var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.864 4.65466H12.718C13.792 4.65466 14.6667 5.56332 14.6667 6.68066V11.3073C14.6667 12.424 13.792 13.3333 12.718 13.3333H3.94867C2.874 13.3333 2 12.424 2 11.3073V6.68066C2 5.56332 2.874 4.65466 3.94867 4.65466H4.79133C4.80128 4.65328 4.81077 4.65063 4.82018 4.64801C4.83348 4.64431 4.84661 4.64066 4.86067 4.64066C4.87516 4.64066 4.88828 4.64434 4.9015 4.64806C4.91078 4.65066 4.92011 4.65328 4.93 4.65466H5.93933C6.146 3.52666 7.138 2.66666 8.33267 2.66666C9.52733 2.66666 10.5193 3.52666 10.7253 4.65466H11.726C11.7355 4.6533 11.7445 4.65073 11.7536 4.64816C11.7668 4.64441 11.78 4.64066 11.7947 4.64066C11.8093 4.64066 11.8228 4.64443 11.8363 4.6482C11.8454 4.65075 11.8546 4.65331 11.864 4.65466ZM9.72133 4.65466C9.53533 4.06532 8.98667 3.63332 8.33267 3.63332C7.678 3.63332 7.12933 4.06532 6.94333 4.65466H9.72133ZM2.97467 11.3073V6.68066C2.97467 6.09732 3.41133 5.62132 3.94867 5.62132H4.37333V12.366H3.94867C3.41133 12.366 2.97467 11.8907 2.97467 11.3073ZM13.692 11.3073C13.692 11.8907 13.2553 12.366 12.718 12.366H12.282V5.62132H12.718C13.2553 5.62132 13.692 6.09732 13.692 6.68066V11.3073ZM5.34867 12.366H11.308V5.62132H5.34867V12.366Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/Suitcase.238c2364b3d1b97e3fd97474e325c60a.svg";
export { ForwardRef as ReactComponent };